export enum OrdersAutoCancelPaymentStatus {
  PENDING = "pending",
  VOIDED = "voided",
}

export default OrdersAutoCancelPaymentStatus;
